export enum RaffleResultScheduleTypeEnum {
  LOTTERY = "lottery",
  RANDOM = "random",
}

export enum RaffleResultScheduleStatusEnum {
  WAITING = "w",
  PROCESSING = "p",
  DONE = "d",
  FAIL = "f",
  CANCELED = "c",
}

export type RaffleResultScheduleTypeTypes =
  | RaffleResultScheduleTypeEnum.LOTTERY
  | RaffleResultScheduleTypeEnum.RANDOM;

export type RaffleResultScheduleStatusTypes =
  | RaffleResultScheduleStatusEnum.WAITING
  | RaffleResultScheduleStatusEnum.PROCESSING
  | RaffleResultScheduleStatusEnum.DONE
  | RaffleResultScheduleStatusEnum.FAIL
  | RaffleResultScheduleStatusEnum.CANCELED;
